import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import PurchaseRequestForm from '../purchase_request_form/PurchaseRequestForm';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { PURCHASE_REQUESTS_CRUD_ACTION_CREATORS } from '../../actions/purchase_requests_actions';

const { Content } = Layout;

const NewPurchaseRequestPage: FC<any> = ({ history, removePRFromRedux }): React.ReactElement => {
	const onSuccess = useCallback(
		(record) => {
			removePRFromRedux(record);
			history.push(`/supplier/purchaseRequests/detail/${record.id}`);
		},
		[history, removePRFromRedux]
	);

	return (
		<Content>
			<LogOnMountWithStandardEventProperties eventType="visited supplier new purchase request page" />
			{/*<ScrollToTopOnMount/>*/}
			{/*<BackTop/>*/}
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<h5 style={{ marginBottom: 24 }}>New Purchase Request</h5>
							<PurchaseRequestForm formData={{}} onSuccess={onSuccess} />
						</div>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

const mapDispatchToProps = (dispatch) => ({
	removePRFromRedux: (entity) =>
		dispatch(PURCHASE_REQUESTS_CRUD_ACTION_CREATORS.deleteSuccess(entity)),
});

export default withRouter(connect(null, mapDispatchToProps)(NewPurchaseRequestPage));
